var _defs, _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    width: 1280,
    height: 1280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-Full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f1"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: -2.7554552980815448e-15,
    dy: 45,
    stdDeviation: 1.25,
    floodColor: "#000000",
    floodOpacity: 0.1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #800020;stroke: #600118;stroke-linejoin: round;stroke-width: 50 } \n\t\t.s1 { filter: url(#f1);fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m150 0h980c82.8 0 150 67.2 150 150v980c0 82.8-67.2 150-150 150h-980c-82.8 0-150-67.2-150-150v-980c0-82.8 67.2-150 150-150z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "KI",
    className: "s1",
    d: "m278.4 889v-498.1h168v203.4h52.1l96.3-203.4h167.2v32.6l-114.4 214.3 131.1 218.6v32.6h-175.9l-107.2-197.7h-49.2v197.7zm555.3 0v-498.1h167.2v498.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiLogo);
export default __webpack_public_path__ + "static/media/ki-logo.3fd7c253df839328649e732f56356d6f.svg";
export { ForwardRef as ReactComponent };